<template>
  <swiper-slide style="cursor: pointer">
    <b-img
      :id="`pop-target-${index}`"
      @click="handleGoToCornerClick"
      v-bind="mainProps"
      :src="imgURL"
      fluid
      rounded
      alt="Rounded image"
    />
    <b-popover
      :target="`pop-target-${index}`"
      triggers="hover"
      placement="top"
      delay="{show:100}"
    >
      <template #title>{{ title }}</template>
      *Coming Soon*
    </b-popover>
  </swiper-slide>
</template>

<script>
import { SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper.scss";

export default {
  name: "OurBooks",
  components: {
    SwiperSlide
  },
  props: {
    publishing: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      mainProps: { blank: false, width: 350, height: 350, class: "m1" }
    };
  },
  computed: {
    imgURL() {
      return this.publishing && this.publishing.doc
        ? this.publishing.doc.imgURL
        : "";
    },
    slug() {
      return this.publishing && this.publishing.slug
        ? this.publishing.slug
        : "";
    },
    title() {
      return this.publishing && this.publishing.doc
        ? this.publishing.doc.title
        : "";
    },
    author() {
      return this.publishing && this.publishing.doc
        ? this.publishing.doc.title
        : "";
    },
    description() {
      return this.publishing.doc.description;
      /*if(this.editor && this.publishing && this.publishing.doc && this.editor.hasOwnProperty('commands')) {
        //console.log(`Setting data`);
        //this.editor.commands.setContent(this.publishing.doc.description, false);
        //console.log(`TEXT ${this.editor.getHTML()}`);
        //return this.editor.getHTML();
      }*/
      return "";
    }
  },
  methods: {
    handleGoToCornerClick() {
      this.$router.push(`/corner/${this.slug}`);
    }
  }
};
</script>
<style lang="scss" scoped>
.swiper-slide {
  width: 10%;
}
.swiper-slide:nth-child(2n) {
  width: 10%;
}
.swiper-slide:nth-child(3n) {
  width: 10%;
}
</style>
